import { Operation } from '../../../__generated__/globalTypes'

import deleteReminderString from '../DeleteReminder.graphql'

export type DeleteReminderData = {
  deleteReminder: {
    deleted: boolean
  }
}

export type DeleteReminderVariables = {
  id: string
}

export type DeleteReminder = Operation<
  DeleteReminderData,
  DeleteReminderVariables
>

export const DeleteReminder = ({
  id,
}: DeleteReminderVariables): DeleteReminder => ({
  query: deleteReminderString,
  variables: {
    id,
  },
})
